
import { ExportRow, MappingRule } from './types';

export const createExportRow = (
  rule: MappingRule,
  categoryPath: string[],
  reportingClassification: number,
  sortOrders: number[],
  isAfdracht: boolean
): ExportRow => {
  console.log('Creating export row for rule:', rule, 'with path:', categoryPath);

  const row: ExportRow = {
    CatLevel0: categoryPath[0] || '',
    SortOrder0: sortOrders[0],
    CatLevel1: categoryPath[1] || categoryPath[0] || '',
    SortOrder1: sortOrders[1],
    CatLevel2: categoryPath[2] || categoryPath[1] || categoryPath[0] || '',
    SortOrder2: sortOrders[2],
    CatLevel3: categoryPath[3] || categoryPath[2] || categoryPath[1] || categoryPath[0] || '',
    SortOrder3: sortOrders[3],
    CatLevel4: categoryPath[4] || categoryPath[3] || categoryPath[2] || categoryPath[1] || categoryPath[0] || '',
    SortOrder4: sortOrders[4],
    AccountFrom: rule.mainAccountFrom,
    AccountTo: rule.mainAccountTo,
    TeamFrom: rule.teamFrom || '',
    TeamTo: rule.teamTo || '',
    ProjectFrom: rule.projectFrom || '',
    ProjectTo: rule.projectTo || '',
    ReportingClassification: reportingClassification,
    Afdracht: isAfdracht
  };

  console.log('Created row:', row);
  return row;
};

